enum StickyNavPosition {
  Top = 'top',
  Bottom = 'bottom',
}

export default StickyNavPosition;
